import { render } from "./OrderView.vue?vue&type=template&id=7acaaabb"
import script from "./OrderView.vue?vue&type=script&lang=js"
export * from "./OrderView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__